export default __webpack_public_path__ + "static/media/640x300_06.2b3814a0.jpg";